import {sha256} from 'js-sha256'
import {isProd} from 'hiya-common/src/utils/host/AutoHost'

const secret = isProd
  ? 'PkDEx+i7uJs5qyNNYulJVxS4WL0Tq3+V5A'
  : 'MFwwDQYJKoZIhvc3AQEBBQADSwAwSAJBAL'

// 签名函数
export function generateSign(params) {
  const sortedKeys = Object.keys(params).sort()

  const rawStr = sortedKeys.map((key) => `${key}=${params[key]}`).join('&')
  return sha256(rawStr + secret)
}
